import {
  LANDING_LANGUAGE_STORAGE_KEY,
  normalizeLanguage,
  type AppLanguage,
} from './constants';

export const LANDING_DEFAULT_LANGUAGE: AppLanguage = 'sr';

export function getLandingLanguage(): AppLanguage {
  if (typeof window === 'undefined') {
    return LANDING_DEFAULT_LANGUAGE;
  }
  const raw = localStorage.getItem(LANDING_LANGUAGE_STORAGE_KEY);
  if (raw == null || raw.trim() === '') {
    return LANDING_DEFAULT_LANGUAGE;
  }
  return normalizeLanguage(raw);
}

export function setLandingLanguage(lang: AppLanguage): void {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.setItem(LANDING_LANGUAGE_STORAGE_KEY, normalizeLanguage(lang));
}

export function hasLandingLanguageChoice(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const raw = localStorage.getItem(LANDING_LANGUAGE_STORAGE_KEY);
  return raw != null && raw.trim() !== '';
}
